/* eslint-disable react-hooks/exhaustive-deps */
import { useLiveQuery } from "dexie-react-hooks";
import { useEffect, useMemo, useState } from "react";
import { db } from "~/db/db";
import useSelect from "~components/Form/hooks/useSelect";
import prepareForOptions from "~services/utils/prepareForOptions";

const useTipoCondicao = (formikRef, name = "tipoCondicaoId") => {
  const tipoCondicaoSelect = useSelect("tipoCondicao");
  const [tipoCondicao, setTipoCondicao] = useState(0);

  const [tipoCondicoes, setTipoCondicoes] = useState([]);

  useEffect(() => {
    const fetchTipoCondicoes = async () => {
      const tipoCondicoesArray = [];
      await db.tipoCondicao.each((tipoCondicao) => {
        tipoCondicoesArray.push(tipoCondicao);
      });
      setTipoCondicoes(tipoCondicoesArray);
    };

    fetchTipoCondicoes();
  }, []);

  const optionTipoCondicao = useMemo(() => prepareForOptions(tipoCondicoes, ['codigo', 'nome'], 'id'), [tipoCondicoes]);

  function onChangeTipoCondicao(e) {
    tipoCondicaoSelect.upDateValue(e.value);
    tipoCondicaoSelect.upDateDefaultValue(e || "");
    formikRef.current.setFieldValue(name, e.value);
    setTimeout(() => formikRef.current.setFieldTouched(name, true));
    setTipoCondicao(e.value);
  }

  return {
    tipoCondicoes,
    onChangeTipoCondicao,
    tipoCondicao,
    tipoCondicaoSelect,
    optionTipoCondicao
  };
}

export default useTipoCondicao;